import React from 'react';

/**
 * CSS mockup of the six volumes, styled after the hero book: soot-black
 * leather cover, antique-gold serif lettering, a gold-framed scene panel.
 * Swap for the real box-set render when it is ready.
 */
const HERO_ART = 'https://cdn.magicpatterns.com/uploads/jtzcKXNfQmETCmbLHSyptC/mockup-paid-table-ready-the-5e-megapack-for-game-masters-who-get-paid.png';
const volumes = [{
  n: '01',
  title: 'First Seat',
  sub: 'Levels 1–3',
  art: '52% 50%'
}, {
  n: '02',
  title: 'Session Zero & the Opening Arc',
  sub: 'Levels 1–4',
  art: '44% 60%'
}, {
  n: '03',
  title: 'The Weekly Engine',
  sub: 'Levels 3–7',
  art: '60% 66%'
}, {
  n: '04',
  title: 'Mid-Campaign Arcs',
  sub: 'Levels 5–10',
  art: '50% 42%'
}, {
  n: '05',
  title: 'Special Tables',
  sub: 'Levels 1–5',
  art: '58% 74%'
}, {
  n: '06',
  title: 'Finales & Next Season',
  sub: 'Levels 8–12',
  art: '48% 46%'
}];
export function VolumeStack({
  className = ''
}: {
  className?: string;
}) {
  return <div role="img" aria-label="Paid Table Ready: six volumes, from First Seat (levels 1 to 3) to Finales and Next Season (levels 8 to 12)" className={`relative w-full select-none ${className}`} data-id="element-347" data-mp="18qah34ow44k7">
      <span aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center font-display font-semibold text-gold/10 leading-none text-[42vw] sm:text-[240px] lg:text-[260px]" data-id="element-348" data-mp="3v7fbprvti4i4">
        57
      </span>
      <div className="relative flex items-end justify-center px-2 pb-8 pt-10" data-id="element-349" data-mp="32kch3au9idx5">
        {volumes.map((v, i) => {
        const offset = i - 2.5;
        return <div key={v.n} className="relative -ml-[8%] first:ml-0 w-[25%] aspect-[3/4] overflow-hidden rounded-[4px] bg-[#0d0a08] shadow-cover ring-1 ring-gold/30" style={{
          transform: `rotate(${offset * 4.5}deg) translateY(${Math.abs(offset) * 7}px)`,
          zIndex: 10 - Math.round(Math.abs(offset))
        }} data-id="element-350" data-mp="3bj6l3m9xa6kq" data-mpi={i}>
              {/* spine shadow */}
              <span className="absolute inset-y-0 left-0 w-[6%] bg-black/50" data-id="element-351" data-mp="2rtvmc2bw98ou" />
              {/* gold inner frame */}
              <span className="absolute inset-[5%] rounded-[2px] border border-gold/45" data-id="element-352" data-mp="2nvxx4zi4imlg" />

              <div className="relative flex h-full flex-col items-center px-[12%] pt-[11%] pb-[9%] text-center" data-id="element-353" data-mp="31rjrlm74lyl9">
                <span className="block text-[clamp(4px,1.1vw,8px)] font-semibold uppercase tracking-[0.2em] text-gold/80" data-id="element-354" data-mp="2wsqdpsnxg5kk">
                  Volume {v.n}
                </span>
                <span className="mt-[5%] flex min-h-[2.2em] items-center font-display font-semibold text-gold text-[clamp(6px,1.6vw,12px)] leading-[1.05]" data-id="element-355" data-mp="247p3el0xm8ju">
                  {v.title}
                </span>

                <span className="mt-[6%] block w-full flex-1 overflow-hidden rounded-[2px] border border-gold/50" data-id="element-356" data-mp="2e1yu7ya86ysg">
                  <img src={HERO_ART} alt="" loading="lazy" draggable={false} className="h-full w-full scale-[2.2] object-cover" style={{
                transformOrigin: v.art
              }} data-id="element-357" data-mp="1qc4mtw8oe2fl" />
                </span>

                <span className="mt-[7%] block text-[clamp(4px,1vw,8px)] font-semibold uppercase tracking-[0.16em] text-gold/70" data-id="element-358" data-mp="3o2l32pqf1eu3">
                  {v.sub}
                </span>
              </div>
            </div>;
      })}
      </div>
    </div>;
}